module.exports = __webpack_public_path__ + "6266058fbcf7b0becced276ba047014f.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/StaticPage/ComeBack/assets/sec-4/shein.jpg
// module id = ./app/containers/StaticPage/ComeBack/assets/sec-4/shein.jpg
// module chunks = 40